import { render, staticRenderFns } from "./MarketAgency.vue?vue&type=template&id=4fd917c3&"
import script from "./MarketAgency.vue?vue&type=script&lang=js&"
export * from "./MarketAgency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports